import React, { useContext } from 'react';
import styled from 'styled-components';

import { AppContext } from 'src/components/app-context';

import { Lazy } from 'src/components/lazy';
import { ProductImage as ProductImageComponent } from 'src/components/product-image';

type Props = {
  lazyLoadImage: boolean;
  imageSize: number;
  imageSrc?: string | null;
  name: string;
};

export const ProductMedia = (props: Props) => {
  const { market = { cdn: 'https://cdn.pji.nu' } } = useContext(AppContext);

  const { lazyLoadImage, imageSize, imageSrc, name } = props;

  const fallback = `${market.cdn}/product/standard/280/0.jpg`;

  return lazyLoadImage ? (
    <Lazy offset={0} placeholder={<ImageSkeleton $size={`${imageSize}px`} />}>
      <ProductImage
        src={imageSrc}
        name={name}
        fallback={fallback}
        $size={`${imageSize}px`}
      />
    </Lazy>
  ) : (
    <ProductImage
      src={imageSrc}
      name={name}
      fallback={fallback}
      $size={`${imageSize}px`}
    />
  );
};

type ImageProps = {
  $size: string;
};

const ImageSkeleton = styled.div<ImageProps>`
  width: ${p => p.$size};
  height: ${p => p.$size};
  background: ${p => p.theme.bg.tertiary};
  border-radius: 8px;
`;

const ProductImage = styled(ProductImageComponent)<ImageProps>`
  border-radius: 8px;
  max-width: ${p => p.$size};
`;
